import React, { useState } from 'react';
import Sidebar from './Sidebar';
import { Menu } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const Layout = ({ children }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const { user } = useAuth();

    return (
        <div className="flex min-h-screen bg-zinc-950 text-zinc-100 font-sans selection:bg-blue-600/30 selection:text-blue-200">
            {/* Mobile Header */}
            <div className={`md:hidden fixed top-0 left-0 right-0 bg-zinc-950/80 backdrop-blur-md border-b border-zinc-800/50 p-4 pt-10 flex items-center justify-between z-40 transition-all`}>
                <div className="flex items-center gap-3">
                    <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center font-bold text-white shadow-lg shadow-blue-600/20">MC</div>
                    <span className="font-bold tracking-tight">MCClub</span>
                </div>
                <button onClick={() => setIsSidebarOpen(true)} className="p-2 text-zinc-400 hover:text-white transition-colors">
                    <Menu className="w-6 h-6" />
                </button>
            </div>

            <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

            <main className="flex-1 p-4 md:p-12 pt-28 md:pt-12 overflow-y-auto w-full custom-scrollbar">
                <div className="max-w-[1400px] mx-auto animate-in fade-in slide-in-from-bottom-2 duration-700">
                    {children}
                </div>
            </main>
        </div>
    );
};

export default Layout;
